<template>
  <div class="national-base" :style="`padding-top:${barHeight}px`">
    <van-nav-bar class="van-bar" :title="$t('lang.ActCommon.k009')" left-arrow @click-left="goPrevious">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
      </template>
    </van-nav-bar>

    <img class="bg-img" src="./images/rules-bg.png" :style="{ 'margin-top': `-${barHeight + 46}px` }" />
    <div class="bg-block">
      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k025') }}</div>
        <div class="item-txt" v-if="mexActStartTime && mexActEndTime">
          {{ $t('lang.ActCommon.k026') }}:
          <br />
          <i style="color: #ff9524">{{ mexActStartTime }} - {{ mexActEndTime }}</i>
        </div>
        <div class="item-txt">{{ $t('lang.ActCommon.k042') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k027') }}</div>
        <div class="item-txt">{{ $t('lang.ActCommon.k028') }}</div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Balloons.png" alt="" />
            {{ $t('lang.HolidayBR.k003') }}
          </div>
          <span>
            <i>1</i>
            {{ $t('lang.ActCommon.k084') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Ring.png" alt="" />
            {{ $t('lang.ActCommon.k013') }}
          </div>
          <span>
            <i>3</i>
            {{ $t('lang.ActCommon.k084') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Rose.png" alt="" />
            {{ $t('lang.HolidayBR.k001') }}
          </div>
          <span>
            <i>5</i>
            {{ $t('lang.ActCommon.k084') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Kiss.png" alt="" />
            {{ $t('lang.ActCommon.k052') }}
          </div>
          <span>
            <i>15</i>
            {{ $t('lang.ActCommon.k084') }}
          </span>
        </div>
        <div class="gift-num" style="margin-top: 16px">
          <div>
            <img src="@/assets/packageAssets/common/Treasure.png" alt="" />
            {{ $t('lang.ActCommon.k051') }}
          </div>
          <span>
            <i>50</i>
            {{ $t('lang.ActCommon.k084') }}
          </span>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k014') }}</div>
        <div class="item-txt">{{ $t('lang.ActCommon.k029') }}</div>
        <div class="national-item" style="margin-top: 16px">
          <div class="reward-num">10 {{ $t('lang.ActCommon.k084') }}</div>
          <div class="reward-coins">
            70
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">15 {{ $t('lang.ActCommon.k084') }}</div>
          <div class="reward-coins">
            80
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">20 {{ $t('lang.ActCommon.k084') }}</div>
          <div class="reward-coins">
            100
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k032') }}</div>
        <div class="item-txt">{{ $t('lang.ActCommon.k033') }}</div>

        <div class="national-item" style="margin-top: 16px">
          <div class="reward-num">No.1</div>
          <div class="reward-coins">
            5000
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.2</div>
          <div class="reward-coins">
            3000
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.3</div>
          <div class="reward-coins">
            2000
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="national-item">
          <div class="reward-num">No.4-10</div>
          <div class="reward-coins">
            800
            <img class="coins-icon" :src="getMatchImg('beans')" />
          </div>
        </div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k030') }}</div>
        <div class="item-txt">{{ $t('lang.ActCommon.k007') }}</div>
      </div>

      <div class="item-block">
        <div class="item-tit">{{ $t('lang.ActCommon.k031') }}</div>
        <div class="item-txt">{{ $t('lang.ActCommon.k008') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfoBr } from './apidir/api.js'

export default {
  data() {
    return {
      mexActStartTime: '',
      mexActEndTime: ''
    }
  },
  methods: {
    // 获取数据
    fetchData() {
      holidayActBaseInfoBr().then((resData) => {
        if (resData.startTimestamp) {
          this.mexActStartTime = this.handleMoment(resData.startTimestamp, 'YYYY-MM-DD HH:mm:ss')
        }
        if (resData.endTimestamp) {
          this.mexActEndTime = this.handleMoment(resData.endTimestamp, 'YYYY-MM-DD HH:mm:ss')
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
img:not([src]) {
  opacity: 0;
}

.national-base {
  width: 100%;
  min-height: calc(100vh - 150px);
  background: #20a438;

  .bg-img {
    width: 100%;
  }

  .bg-block {
    position: relative;
    margin-top: -50px;
    min-height: 100vh;

    padding: 20px 10px;

    .item-block {
      width: 100%;
      padding: 16px;
      margin-bottom: 16px;
      background: #f4faf2;
      border-radius: 12px;

      .item-tit {
        line-height: 22px;
        font-family: 'TikTokSans-Regular';
        font-weight: 600;
        font-size: 17px;
        color: #076229;
        line-height: 22px;
      }

      .item-txt {
        width: 323px;
        line-height: 22px;
        font-family: 'TikTokSans-Regular';
        font-weight: 400;
        font-size: 15px;
        color: #576f60;
        margin-top: 8px;
      }

      .gift-num {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        > div {
          display: flex;
          align-items: center;
          gap: 10px;

          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 17px;
          color: #295948;
          line-height: 20px;

          img {
            width: 24px;
            height: 24px;
          }
        }
        > span {
          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 17px;
          color: #295948;
          line-height: 20px;
          text-align: right;
        }
      }

      .national-item {
        font-family: 'TikTokSans-Regular';
        font-weight: 400;
        font-size: 15px;
        color: #295948;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .reward-coins {
          display: flex;
          align-items: center;
          font-weight: bold;
          .coins-icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'Inter-Regular';
  font-weight: 600;
  color: #ffffff;
}
</style>
